import * as React from "react";
import { FontSizes, FontWeights, getTheme, Label, Stack, Spinner, SpinnerSize, FontIcon, mergeStyles, IStackStyles, IStackTokens } from "@fluentui/react";
import { getFilePreview } from "../../services/GraphService"
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { IFileItem } from "../../interfaces/IFileItem";

const labelStyle = {
    root: {
        fontSize: FontSizes.smallPlus,
        color: getTheme().palette.themeDarkAlt,
        fontWeight: FontWeights.regular,
        cursor: "pointer"
    }
};
const previewContainerStyle = { height: 275, width: "100%", marginTop: 15 };
// const chevronStyle = { marginLeft: 5, color: getTheme().palette.themeDarkAlt };
export const chevronStyle = mergeStyles({
    marginLeft: 5,
    color: getTheme().palette.themeDarkAlt
});
const spinnerStyle = { height: 339, width: "100%" };

const expandCollapseStackTokens: IStackTokens = {
    childrenGap: 5
};

const expandCollapseStackStyles: Partial<IStackStyles> = {
    root: {
        cursor: "pointer",
        marginTop: 10,
        marginBottom: 5,
    }
};

interface PreviewFileProps {
    fileItem: IFileItem,
    unknownItem: boolean,
    refreshPreview?: boolean
}

const PreviewFile: React.FunctionComponent<PreviewFileProps> = ({
    fileItem,
    unknownItem,
    refreshPreview
}: PreviewFileProps) => {
    const languageStrings = React.useContext(LanguageContext);
    const [previewURL, setPreviewURL] = React.useState<string>("");
    const [isPreviewHidden, setIsPreviewHidden] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        const asyncWrapper = async () => {
            if (fileItem?.driveId && fileItem?.id) {
                generatePreviewData();
            }
        }
        asyncWrapper();
    }, [fileItem]);

    React.useEffect(() => {
        const asyncWrapper = async () => {
            if (fileItem?.driveId && fileItem?.id && refreshPreview) {
                generatePreviewData();
            }
        }
        asyncWrapper();
    }, [refreshPreview]);  
    
    const generatePreviewData = async () => {
        const preview = await getFilePreview(fileItem.driveId, fileItem.id);
        if (preview) {
            setPreviewURL(preview);
        } else {
            setIsPreviewHidden(true);
        }
        setIsLoading(false);
    }

    React.useEffect(() => {
        if (unknownItem === true) {
            setIsPreviewHidden(true);
            setIsLoading(false);
        }
    }, [unknownItem])

    return (
        <>
            {!isLoading ?
                <>
                    <iframe src={previewURL} style={previewContainerStyle} hidden={isPreviewHidden} />
                    <Stack horizontal verticalAlign="center" onClick={() => { setIsPreviewHidden(!isPreviewHidden) }} tokens={expandCollapseStackTokens} styles={expandCollapseStackStyles}>
                        <FontIcon iconName={!isPreviewHidden ? "ChevronUp" : "ChevronDown"} className={chevronStyle} />
                        <Label styles={labelStyle}>
                            {isPreviewHidden ? languageStrings.ShowPreview : languageStrings.HidePreview}
                        </Label>
                    </Stack>
                </>
                :
                <Stack style={spinnerStyle} verticalAlign="center" horizontalAlign="center">
                    <Spinner size={SpinnerSize.medium} />
                </Stack>}
        </>
    );
};
export default PreviewFile;
